var _circle, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path5, _path6, _path7, _path8, _ellipse, _path9, _rect11, _path10, _path11, _circle2, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCandidates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 86,
    fill: "#F2FBFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 60.0372,
    width: 70.5382,
    height: 86.2134,
    rx: 6.96674,
    transform: "rotate(-5.72562 35 60.0372)",
    fill: "#CAF0F8",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8857,
    y: 52.906,
    width: 62.8604,
    height: 76.8294,
    rx: 6.20844,
    transform: "rotate(16.8433 91.8857 52.906)",
    fill: "#CAF0F8",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.796,
    y: 39.4287,
    width: 67.1605,
    height: 82.2716,
    rx: 6.2963,
    transform: "rotate(16.7054 86.796 39.4287)",
    fill: "white",
    stroke: "#90E0EF",
    strokeWidth: 0.839506
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.2041 85.0625C98.137 81.9539 101.413 80.1902 104.522 81.1232L113.367 83.7777C116.475 84.7106 118.239 87.9868 117.306 91.0954L116.582 93.5076L96.4801 87.4747L97.2041 85.0625Z",
    fill: "#00B4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.096 69.6248C107.629 67.8485 109.501 66.8407 111.278 67.3738L115.298 68.5803C117.074 69.1134 118.082 70.9856 117.549 72.7619L117.308 73.566C118.196 73.8325 118.7 74.7686 118.433 75.6568C118.167 76.5449 117.231 77.0488 116.343 76.7823L115.619 79.1945C115.086 80.9708 113.213 81.9787 111.437 81.4456L110.954 83.0537L110.914 83.0416C110.902 83.1795 110.875 83.3181 110.834 83.4557C110.501 84.5659 109.331 85.1958 108.22 84.8626C107.11 84.5295 106.48 83.3594 106.813 82.2492C106.855 82.1115 106.909 81.9812 106.974 81.8592L106.934 81.8471L107.417 80.239C105.64 79.7059 104.633 77.8337 105.166 76.0574L105.89 73.6452C105.001 73.3786 104.498 72.4426 104.764 71.5544C105.031 70.6662 105.967 70.1623 106.855 70.4289L107.096 69.6248Z",
    fill: "#ADE8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.764 77.0231C112.604 77.5563 112.239 78.004 111.749 78.2679C111.259 78.5317 110.684 78.59 110.151 78.43C109.618 78.27 109.17 77.9048 108.906 77.4147C108.642 76.9246 108.584 76.3497 108.744 75.8166L110.754 76.4198L112.764 77.0231Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.002 64.9617C110.226 64.4286 108.354 65.4364 107.821 67.2127L107.82 67.2126L105.89 73.6453L106.694 73.8866L107.901 69.8662L116.745 72.5207L115.539 76.541L116.343 76.7824L117.549 72.762L117.55 72.7621L119.239 67.1335L112.002 64.9617Z",
    fill: "#03045E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82.73,
    y: 89.4836,
    width: 45.3333,
    height: 2.51852,
    transform: "rotate(16.7054 82.73 89.4836)",
    fill: "#EAEAF1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.0408,
    y: 95.1121,
    width: 17.6296,
    height: 2.51852,
    transform: "rotate(16.7054 81.0408 95.1121)",
    fill: "#EAEAF1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 78.8689,
    y: 102.349,
    width: 13.4321,
    height: 5.87654,
    rx: 1.67901,
    transform: "rotate(16.7054 78.8689 102.349)",
    fill: "#ADE8F4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 94.1464,
    y: 106.934,
    width: 13.4321,
    height: 5.87654,
    rx: 1.67901,
    transform: "rotate(16.7054 94.1464 106.934)",
    fill: "#ADE8F4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 109.424,
    y: 111.519,
    width: 13.4321,
    height: 5.87654,
    rx: 1.67901,
    transform: "rotate(16.7054 109.424 111.519)",
    fill: "#ADE8F4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4854,
    y: 50.5609,
    width: 67.2041,
    height: 88.3899,
    rx: 6.75813,
    transform: "rotate(-5.72562 42.4854 50.5609)",
    fill: "#03045E",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1764,
    y: 43.3357,
    width: 80,
    height: 98,
    rx: 7.5,
    transform: "rotate(-6.371 24.1764 43.3357)",
    fill: "white",
    stroke: "#90E0EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0217 62.4763C59.8072 60.5552 61.1907 58.824 63.1117 58.6095L69.0747 57.9437C70.9958 57.7292 72.727 59.1127 72.9415 61.0337C73.156 62.9548 71.7725 64.686 69.8515 64.9005L63.8885 65.5663C61.9674 65.7808 60.2362 64.3973 60.0217 62.4763Z",
    fill: "#03045E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7061 68.7721C57.3077 65.2044 59.877 61.9893 63.4447 61.591C67.0123 61.1926 70.2274 63.7619 70.6258 67.3296L70.6813 67.8265L57.7616 69.269L57.7061 68.7721Z",
    fill: "#03045E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5949 66.7747C75.1965 63.2071 71.9814 60.6378 68.4137 61.0362C64.8461 61.4345 62.2768 64.6496 62.6752 68.2173L62.7306 68.7142L75.6504 67.2717L75.5949 66.7747Z",
    fill: "#03045E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6506 68.2752L75.5394 66.2778L77.3149 82.179L59.426 84.1764L57.6506 68.2752Z",
    fill: "#03045E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.4248,
    cy: 70.2025,
    rx: 6.5,
    ry: 8,
    transform: "rotate(-6.371 67.4248 70.2025)",
    fill: "#ADE8F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3594 74.0114C69.4035 74.4067 69.2888 74.8034 69.0405 75.1142C68.7921 75.425 68.4305 75.6244 68.0351 75.6685C67.6397 75.7127 67.243 75.598 66.9323 75.3496C66.6215 75.1013 66.4221 74.7396 66.3779 74.3443L67.8687 74.1778L69.3594 74.0114Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 65.717,
    y: 77.4367,
    width: 5,
    height: 3,
    transform: "rotate(-6.371 65.717 77.4367)",
    fill: "#ADE8F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0772 62.9732L69.0216 61.9745C69.3893 65.2677 67.0177 68.2355 63.7245 68.6032L60.743 68.9361L60.0772 62.9732Z",
    fill: "#03045E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8884 88.4846C56.4594 84.6425 59.2263 81.1801 63.0684 80.7511L73.0066 79.6414C76.8488 79.2124 80.3112 81.9793 80.7402 85.8214L81.0731 88.8029L57.2213 91.4661L56.8884 88.4846Z",
    fill: "#0096C7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.5899,
    cy: 80.6377,
    r: 2.5,
    transform: "rotate(-6.371 68.5899 80.6377)",
    fill: "#ADE8F4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 66.0402,
    y: 62.3074,
    width: 6,
    height: 3,
    transform: "rotate(-6.371 66.0402 62.3074)",
    fill: "#03045E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 43.0908,
    y: 100.087,
    width: 54,
    height: 3,
    transform: "rotate(-6.371 43.0908 100.087)",
    fill: "#EAEAF1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8675,
    y: 107.044,
    width: 21,
    height: 3,
    transform: "rotate(-6.371 43.8675 107.044)",
    fill: "#EAEAF1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8662,
    y: 115.989,
    width: 16,
    height: 7,
    rx: 2,
    transform: "rotate(-6.371 44.8662 115.989)",
    fill: "#ADE8F4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 63.7489,
    y: 113.88,
    width: 16,
    height: 7,
    rx: 2,
    transform: "rotate(-6.371 63.7489 113.88)",
    fill: "#ADE8F4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 82.6315,
    y: 111.772,
    width: 16,
    height: 7,
    rx: 2,
    transform: "rotate(-6.371 82.6315 111.772)",
    fill: "#ADE8F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCandidates);
export default __webpack_public_path__ + "static/media/NoCandidates.71857fd6fa2ad76ee612933dcb7dbdc6.svg";
export { ForwardRef as ReactComponent };